import React from 'react'
import { Select } from '@mui/material'

const TableSelectField: React.FC<any> = (props) => {
  const { children, style, ...rest } = props

  const selectStyle: React.CSSProperties = {
    fontSize: '12px',
    ...style,
  }

  return (
    <Select style={selectStyle} {...rest}>
      {children}
    </Select>
  )
}

export default TableSelectField
